<template>
  <kye-dialog
    width="388px"
    title="拨打电话"
    custom-class="kye-call-dialog"
    :append-to-body="appendToBody"
    :visible.sync="show"
    @close="close">
    <div style="text-align: center;padding: 15px">
      <img src="./img.png" style="height: 57px;width: 51px;object-fit: fill">
    </div>
    <div class="kye-call-dialog__body" v-loading="loading">
      <div class="kye-call-dialog__tip1">将使用<span>此座机</span>进行拨打，如需使用其他座机请修改</div>
      <div class="kye-call-dialog__content">
        <el-autocomplete
          ref="searchTips"
          :class="{ 'kye-call-dialog__error-border': !!errorMsg }"
          :fetch-suggestions="handleChange"
          @select="handleSelect"
          @input="handleInput"
          placeholder="请输入座机号码">
          <template slot-scope="{ item }">
            <p>{{ item.landlineNumber }}</p>
          </template>
        </el-autocomplete>
        <el-tooltip popper-class="kye-call-dialog__tip" effect="light" placement="top">
          <div slot="content">
            <!--            <p>号码需要输入座机，格式例如：</p>-->
            <p>总部：0755232333001（07552323+分机号）</p>
            <p>非总部：02163868686（区号+座机号码）</p>
          </div>
          <img src="./tip.svg"/>
        </el-tooltip>
        <p class="kye-call-dialog__error" v-if="errorMsg">{{ errorMsg }}</p>
      </div>
      <div
        class="kye-call-dialog__config">
        <p style="font-size: 12px;line-height: 12px"><i class="el-icon-warning" style="color:#FF9300;margin-right: 2px;"></i>首次使用需设置常用座机
        </p>
        <kye-button type="text" :disabled="!deviceId" @click="useClick" icon="layout layout-config">常用座机
        </kye-button>
      </div>
      <slot name="customContent"></slot>
      <!-- <kye-checkbox class="kye-call-dialog__checkbox" v-model="form.isVirtualPhoneCall">使用虚拟号码拨打</kye-checkbox> -->
      <!--      <div class="kye-call-dialog__tip2">提示：首次使用需维护常用座机，常用座机将与电脑进行绑定。</div>-->
    </div>
    <template slot="footer">
      <kye-button type="text" v-if="showMeetingBtn" @click="handleMeetingCall">发起会议</kye-button>
      <kye-button type="primary"
                  @click="handleEncryptCall"
                  :disabled="!!errorMsg || !!encryptCall">{{ encryptCall ? encryptCall : '加密呼叫' }}
      </kye-button>
      <kye-button type="primary"
                  @click="handleCall(0)"
                  :disabled="!!errorMsg || !!plainCall">{{ plainCall ? plainCall : '明文呼叫' }}
      </kye-button>
      <kye-button @click="close">取消</kye-button>
    </template>

    <kye-dialog title="常用座机维护" :visible.sync="useShow" width="690px" :append-to-body="appendToBody">
      <div class="user-content">
        <p class="call-tip"><i class="el-icon-warning"></i>首次使用需设置常用座机，常用座机将与电脑进行绑定。</p>
        <!--        <p style="margin-bottom: 4px;font-size:14px; color: #333;">当前设备ID：{{ this.deviceId }}</p>-->
        <kye-button type="text" icon="iconfont icon-plus" @click="handleAdd">新增座机</kye-button>
        <el-table :data="useList" border fit highlight-current-row class="kye-table-fix" v-loading="useLoading">
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <kye-button type="text" v-if="!scope.row.id" @click="handleSave(scope.row, scope.$index)">保存</kye-button>
              <kye-button type="text" v-if="!scope.row.id" @click="handleCancel(scope.$index)">取消</kye-button>
              <kye-button type="text" v-if="scope.row.id" @click="handleDel(scope.row, scope.$index)">删除</kye-button>
            </template>
          </el-table-column>
          <el-table-column label="座机号码" width="120" :render-header="renderNumberHeader">
            <template slot-scope="scope">
              <kye-input v-if="!scope.row.id" v-model="scope.row.landlineNumber" clearable></kye-input>
              <span v-else>{{ scope.row.landlineNumber }}</span>
            </template>
          </el-table-column>
          <el-table-column label="设备ID" prop="deviceId"></el-table-column>
          <el-table-column label="资产编码" width="120" prop="assetsCode"></el-table-column>
        </el-table>
      </div>
    </kye-dialog>
  </kye-dialog>
</template>

<script>
  import tipImg from './tip.svg'

  export default {
    props: {
      appendToBody: {
        type: Boolean,
        default: false
      },
      showMeetingBtn: { // 是否显示隐藏发起会议按钮
        type: Boolean,
        default: false
      },
      extParams: { // 呼叫额外传参
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        loading: false,
        show: false,
        deviceId: '',
        assetsCode: '',
        result: [],
        useLoading: false,
        useShow: false,
        useList: [],
        form: {
          callNumber: '',
          calledNumberEncrypt: ''
          // isVirtualPhoneCall: 0
        },
        errorMsg: '',
        currentValue: '',
        encryptCall: '',
        plainCall: '',
        timer: null,
        succsss: null
      }
    },
    methods: {
      renderNumberHeader (h, {column, $index}) {
        // console.log(col, 8888)
        let label = h('span', column.label)
        let lineText1 = h('p', '总部：07552323+分机号，如0755232333001')
        let lineText2 = h('p', '非总部：区号+座机号码，如021638686')
        let text = h('div', {}, [lineText1, lineText2])
        let popover = h('el-popover', {
          props: {
            placement: 'top',
            trigger: 'hover'
          },
          style: {
            display: 'flex',
            alignItems: 'center'
          }
        }, [
          h('img', {
            slot: 'reference',
            attrs: {
              src: tipImg
            },
            style: {
              marginLeft: '5px',
              width: '12px'
            }
          }),
          text
        ])
        return h('span', {
          style: {
            display: 'flex',
            alignItems: 'center'
          }
        }, [
          label,
          popover
        ])
      },
      /**
       * 初始化
       */
      init (option = {}) {
        this.form.callNumber = option.callNumber || ''
        this.form.calledNumberEncrypt = option.calledNumberEncrypt || ''
        this.succsss = option.succsss
        this.getUserDevice()
        this.show = true
      },
      /**
       * 获取用户设备信息
       */
      async getUserDevice () {
        try {
          this.loading = true
          let res = await this.$http('basevirtual.landline.getCurrentDeviceInfo', {}, { appkey: 55041 })
          if (res) {
            this.deviceId = res.deviceId
            this.assetsCode = res.assetsCode
            this.getNumberList()
          } else {
            this.loading = false
          }
        } catch (err) {
          this.deviceId = ''
          this.assetsCode = ''
          this.loading = false
        }
      },
      /**
       * 获取用户设备列表
       */
      async getNumberList () {
        try {
          let res = await this.$http('basevirtual.landlineInfo.list', { deviceId: this.deviceId }, { appkey: 55041 })
          if (res && res.length) {
            this.result = res.map(v => v)
            // 默认选中第一个
            this.$nextTick(_ => {
              this.$refs.searchTips.$refs.input.currentValue = res[0].landlineNumber
            })
          }
          this.loading = false
        } catch (err) {
          this.result = []
          this.loading = false
        }
      },
      handleEncryptCall () {
        this.handleCall(1)
      },
      // 发起会议
      async handleMeetingCall () {
        let curVal = this.$refs.searchTips.$refs.input.currentValue
        let params = {
          callerNumber: curVal,
          calledNumber: this.form.callNumber,
          deviceId: this.deviceId,
          calledNumberEncrypt: this.form.calledNumberEncrypt,
        }
        try {
          let res = await this.$http('basevirtual.landline.addConferenceMember', params, { appkey: 55041 })
          if (res) {
            this.$message.success('添加成功！')
            this.show = false
          }
          console.log(res)
        } catch (err) {
          console.log(err)
        }
      },
      handleInput (val) {
        if (val && !/^(0\d{2,3}-\d{7,12}|\(?0\d{2,3}[)-]?\d{7,12}|\(?0\d{2,3}[)-]*\d{7,12})$/.test(val)) {
          this.errorMsg = '请输入正确座机号码！'
          return
        }
        this.errorMsg = ''
      },
      /**
       * 呼叫
       */
      handleCall (isVirtualPhoneCall = 0) {
        let curVal = this.$refs.searchTips.$refs.input.currentValue
        const { beforeHandleCall, ...resetParams } = this.extParams || {}
        let params = {
          callerNumber: curVal,
          calledNumber: this.form.callNumber,
          deviceId: this.deviceId,
          calledNumberEncrypt: this.form.calledNumberEncrypt,
          isVirtualPhoneCall: isVirtualPhoneCall,
          ...resetParams
        }
        // 2023-05-15 增加点击呼叫之前的回调
        if (beforeHandleCall && typeof beforeHandleCall === 'function') {
          const before = beforeHandleCall(params)
          if (before.then) {
            before.then(isBreack => {
              if (!isBreack) {
                this.noopCall(params, isVirtualPhoneCall)
              }
            })
          } else if (before !== true) {
            this.noopCall(params, isVirtualPhoneCall)
          }
        } else {
          this.noopCall(params, isVirtualPhoneCall)
        }
      },
      async noopCall (params, isVirtualPhoneCall) {
        try {
          clearInterval(this.timer)
          this.encryptCall = ''
          this.plainCall = ''
          let second = 1
          const res = await this.$http('basevirtual.landline.calloutAsync', params, { appkey: 55041 })
          if (res.code === '0') {
            this.timer = setInterval(async () => {
              if (isVirtualPhoneCall) {
                this.encryptCall = `拨号中(${second++}S)`
              } else {
                this.plainCall = `拨号中(${second++}S)`
              }
              const timeData = await this.$http('basevirtual.landline.calloutAsync', { batchCode: res.msg }, { appkey: 55041 })
              if (timeData.code !== '0') {
                clearInterval(this.timer)
                this.encryptCall = ''
                this.plainCall = ''
                // 虚拟号异常提示手动拨打
                if (+isVirtualPhoneCall === 1 && +timeData.popup === 1 && timeData.virtualPhone) {
                  this.$alert(`<span style="color: var(--g-color-danger);font-weight: bold;">若呼叫异常</span>，请手动拨号<span style="color: var(--g-color-danger);font-weight: bold;">${timeData.virtualPhone}</span>联系对方！`, '提示', {
                    dangerouslyUseHTMLString: true
                  })
                  return
                }
                if (timeData.code === '200') {
                  this.$message.success('已成功呼叫客户，请留意相对应的座机！')
                } else {
                  this.$message.error(timeData.msg || '呼叫失败，请稍后重试！')
                }
                if (this.succsss && typeof this.succsss === 'function') {
                  this.succsss()
                }
                this.$emit('save')
                this.show = false
              }
            }, 1000)
          }
        } catch (err) {
          console.log(err)
        }
      },
      /**
       * 实时搜索
       */
      handleChange (val, cb) {
        let result = val ? this.result.filter(v => String(v.landlineNumber).includes(String(val))) : this.result
        cb(result)
      },
      handleSelect (item) {
        this.$refs.searchTips.$refs.input.currentValue = String(item.landlineNumber)
      },
      close () {
        this.deviceId = ''
        this.assetsCode = ''
        this.result = []
        clearInterval(this.timer)
        this.encryptCall = ''
        this.plainCall = ''
        this.show = false
      },
      /**
       * 常用座机维护
       */
      useClick () {
        this.useShow = true
        this.useList = this.result.map(v => v)
      },
      /**
       * 新增
       */
      handleAdd () {
        this.useList.push({
          deviceId: this.deviceId,
          assetsCode: this.assetsCode,
          deviceOwnerId: this.$store.state.user.id,
          landlineNumber: ''
        })
      },
      /**
       * 保存
       */
      async handleSave (row, index) {
        try {
          if (!row.landlineNumber) {
            this.$message.warning('请输入座机号码')
            return
          }
          if (!/^\d+$/.test(row.landlineNumber)) {
            this.$message.warning('仅允许输入纯数字文本')
            return
          }
          this.useLoading = true
          let res = await this.$http('basevirtual.landlineInfo.save', { ...row }, { appkey: 55041 })
          if (res && res.id) {
            this.$set(this.useList, index, {
              ...row,
              ...res
            })
            this.$refs.searchTips.$refs.input.currentValue = res.landlineNumber
            this.$message.success('新增成功')
            this.updateList()
          }
          this.useLoading = false
        } catch (err) {
          this.useLoading = false
        }
      },
      /**
       * 取消
       */
      handleCancel (index) {
        this.useList.splice(index, 1)
      },
      /**
       * 删除
       */
      async handleDel (row, index) {
        await this.$confirm('此操作将永久删除, 是否继续?', '提示')
        await this.$http('basevirtual.landlineInfo.delete', { ids: [row.id] }, { appkey: 55041 })
        this.$message.success('删除成功')
        this.useList.splice(index, 1)
        this.updateList()
      },
      /**
       * 更新下拉
       */
      updateList () {
        this.result = this.useList.filter(v => !!v.id)
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-dialog__body {
    padding: 0;
  }

  .kye-call-dialog {
    &__body {
      padding: 0px 40px 20px 40px;
    }

    &__content {
      display: flex;
      align-items: center;
      margin-top: 10px;
      position: relative;

      > span {
        color: var(--g-color-primary);
        font-size: 12px;
        margin-left: 12px;
        cursor: pointer;
      }

      img {
        position: absolute;
        right: -16px;
        top: 0;
        margin-top: 8px;
        width: 12px;
        height: 12px;
      }
    }

    &__config {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 14px;
      .el-button.el-button--text {
        padding: 0;
        &:hover {
          border-color: transparent;
          background-color: transparent;
        }
      }
    }

    &__encrypt-btn {
      background-color: #f1eaff;
      color: #b69dec;
      border-color: #f1eaff;

      &:not(.is-disabled):hover {
        background-color: #f1eaff;
        color: #b69dec;
        border-color: #f1eaff;
      }
    }

    // &__checkbox {
    //   margin: 10px 0;
    //   font-size: 12px;
    //   /deep/ .el-checkbox__label {
    //     color: #333333;
    //   }
    // }
    &__tip1 {
      font-size: 14px;
      font-weight: 500;
      color: #333333;

      > span {
        color: #ff9300;
      }
    }

    &__tip2 {
      color: #999999;
      font-weight: 400;
      font-size: 12px;
      margin-top: 12px;
    }

    &__error-border {
      /deep/ .el-input__inner {
        border-color: #ff5555;
      }
    }

    &__error {
      position: absolute;
      top: 26px;
      left: 0;
      font-size: 12px;
      color: #ff5555;
    }

    .user-content {
      padding: 0 16px 12px;

      .call-tip {
        height: 32px;
        background: #fff8ee;
        line-height: 32px;
        font-size: 12px;
        font-weight: 400;
        text-align: left;
        color: #ff9300;
        margin: 0 -16px;
        padding: 0 16px;

        > i {
          margin-right: 6px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/kye-field-call/call-dialog.vue